<template>
    <div class="d-none"/>
</template>

<script>
export default {
    props: {
        firebaseUid: String,
    },

    mounted() {
        window.Echo.private('users.' + this.firebaseUid).listen('.toast', this.showNotification)
    },

    methods: {
        showNotification(toast) {
            toastr.showToast(
                toast.type,
                toast.message,
                toast.title,
                toast.timeoutInSeconds * 1000
            );
        },
    },
}
</script>
